export const maskImageId = "ai-mask-image";
